import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const StepIndicator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const steps = [
    { number: 1, label: "Select Scans", path: "/scans/new/scans" },
    { number: 2, label: "Select Targets", path: "/scans/new/targets" },
    { number: 3, label: "Configure", path: "/scans/new/configure" },
    { number: 4, label: "Review", path: "/scans/new/review" },
  ];

  const currentStep = steps.find(step => location.pathname === step.path);
  const currentStepNumber = currentStep?.number || 1;

  const previousStep = steps[currentStepNumber - 2];
  const goBack = () => {
    if (previousStep) {
      navigate(previousStep.path);
    }
  };

  return (
    <div className="step-indicator">
      <button type="button" className="back-button" onClick={goBack} disabled={!previousStep} aria-label="Go back one wizard step">
        ← Back
      </button>
      <div className="steps">
        {steps.map(step => (
          <div
            key={step.number}
            className={`step ${step.number <= currentStepNumber ? "active" : ""} ${step.number === currentStepNumber ? "current" : ""}`}
          >
            <div className="step-number">{step.number}</div>
            <div className="step-label">{step.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
